import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import FirebaseService from 'services/FirebaseService';
import SurveyService from 'services/SurveyService';
import { useDispatch } from 'react-redux';

export const initialState = {
	loading: false,
	message: '',
	showMessage: false,
	redirect: '',
	token: localStorage.getItem(AUTH_TOKEN) || null,
    data: []
}


export const addSurvey = createAsyncThunk('survey/addSurvey', async (data, { rejectWithValue }) => {
	
	try {
		const response = await SurveyService.addSurvey(data)
		if (response.status) {
			console.log(response);
            
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
})

export const getSurvey = createAsyncThunk('survey/getSurvey', async (data, { rejectWithValue }) => {
	
	try {
		const response = await SurveyService.getSurvey(data)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
})

export const SurveySlice = createSlice({
    name: 'survey',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(addSurvey.pending, (state) => {
            state.loading = true
            state.message = ''
        })
        .addCase(addSurvey.fulfilled, (state, action) => {
            state.loading = false
           // state.data.unshift(action.payload);
            state.message = "Survey Added"
        })
        .addCase(addSurvey.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        .addCase(getSurvey.pending, (state) => {
            state.loading = true
            state.message = ''
        })
        .addCase(getSurvey.fulfilled, (state, action) => {
            state.loading = false
            state.data = action.payload
            state.message = ''
        })
        .addCase(getSurvey.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
    }
});



export default SurveySlice.reducer;